import axios from 'axios'
import { useContext, useState } from 'react'
import { useHistory } from 'react-router'
import urlSearchParams from '../../components/urlSearchParams'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, ROUTES, success } from '../../shared/constants'

export const useLeadType = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const history = useHistory()
  const [leadType, setLeadType] = useState(false)
  const { deleteNewLeadType, getNewLeadType } = useContext(ConfigurationContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)

  const getAllLeadType = async (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_ALL_LEADTYPE(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPaginate(data.paginate)
        getNewLeadType(data.data)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || err.response.data.errors[0].msg, error)
        }
      })
  }

  const addLeadType = (dto) => {
    setLoading(true)
    axios
      .post(API.ADD_LEADTYPE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Lead Type  Added Successfully', success)
        history.push(ROUTES.LEAD_TYPE)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || err.response.data.errors[0].msg, error)
        }
      })
  }
  const updateLeadType = (dto) => {
    setLoading(true)
    axios
      .put(API.EDIT_LEADTYPE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('LeadType  Update Successfully', success)
        history.push(ROUTES.LEAD_TYPE)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || err.response.data.errors[0].msg, error)
        }
      })
  }

  const getLeadType = (dto) => {
    setLoading(true)
    axios
      .get(API.GET_LEADTYPE(dto.leadTypeId), header)
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        setLeadType(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || err.response.data.errors[0].msg, error)
        }
      })
  }

  const deleteLeadType = (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_LEADTYPE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('LeadType Deleted Successfully', success)

        deleteNewLeadType(dto.leadTypeId)
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || err.response.data.errors[0].msg, error)
        }
      })
  }

  const deleteManyLeadType = (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_MANY_LEADTYPE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage(`${dto.leadTypeId.length} LeadType Deleted Successfully`, success)

        dto.leadTypeId.map((item) => deleteNewLeadType(item))
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || err.response.data.errors[0].msg, error)
        }
      })
  }

  const BulkUpload = async (dto) => {
    setLoading(true)
    axios
      .post(API.BULK_UPLOAD, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        // data.data.map((item) => addNewReg(item))
        toastMessage(`${data.data.length} Data Inserted Successfully`, success)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  return {
    addLeadType,
    getAllLeadType,
    deleteLeadType,
    getLeadType,
    leadType,
    updateLeadType,
    deleteManyLeadType,
    BulkUpload,
    loading,
    paginate,
  }
}
